// Language Selector

if ( (document.body.clientWidth <= 480) ) {
  $('.c-top-header .c-language').appendTo( $( ".c-header .o-container" ) );
}

$('.c-language__selected').on('click', function (e) {
    $(this).toggleClass('active');
    $(this).next('.c-language__select').toggleClass('active');
});
